import { useCreateOrderDocumentLink } from '../useCreateOrderDocumentLink'

export type UseOrderInvoiceUrlResult = () => Promise<string>

/** Returns a function that creates a link for the order and resolves to its public invoice address. */
export const useOrderInvoiceUrl = ({
  rootUrl,
  orderId,
}: {
  rootUrl: string
  orderId?: string
}): UseOrderInvoiceUrlResult => {
  const { mint } = useCreateOrderDocumentLink()

  return async (): Promise<string> => {
    const { token } = await mint(orderId)
    return `${rootUrl}/invoice/view/${token}`
  }
}
